import { useCallback } from 'react';
import { apiClient } from '../api';

export function useAnalytics() {
  const track = useCallback(
    (event: string, properties: Record<string, unknown> = {}) => {
      apiClient.analytics(event, properties, false);
    },
    []
  );

  const identify = useCallback((traits: Record<string, unknown> = {}) => {
    apiClient.analytics(undefined, traits, true);
  }, []);

  const page = useCallback(
    (pageName: string, properties: Record<string, unknown> = {}) => {
      track('Page Viewed', { page: pageName, ...properties });
    },
    [track]
  );

  return {
    track,
    identify,
    page,
  };
}
